import {
    getOriented,
    triageMyInbox,
    findQuickWins,
    needsUrgentReplies,
    showTopActionItems,
    latestOnTopic,
    whatToGetToFirst,
    showMyTopThreeEmails,
    type Suggestion,
    type Suggestions,
} from '../utils/suggestionCatalog';
import { isUserCommercialPremium } from './isUserCommercialPremium';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Helper function to navigate the A/B/C/D experiment structure for empty reading pane suggestions.
 * Three strings are being tested, split into three flights.
 * Flight name structure is: copilot-dab-mail-empty-rp-sua-treatment-A, -B, -C
 *
 * Note that the first two suggestions are always static, with only the third suggestion changing based on flight.
 */
export function getEmptyReadingPaneSuggestions(): Suggestions {
    let dynamicThirdSuggestion: Suggestion;

    if (!isUserCommercialPremium()) {
        // Non-Commercial Premium users are excluded from the SUA reading pane experiment,
        // just return original set of three suggestions
        return [triageMyInbox, getOriented, findQuickWins];
    }

    // Otherwise, check for experiment flights
    if (isFeatureEnabled('copilot-dab-mail-empty-rp-sua-treatment-A')) {
        dynamicThirdSuggestion = needsUrgentReplies;
    } else if (isFeatureEnabled('copilot-dab-mail-empty-rp-sua-treatment-B')) {
        dynamicThirdSuggestion = whatToGetToFirst;
    } else if (isFeatureEnabled('copilot-dab-mail-empty-rp-sua-treatment-C')) {
        dynamicThirdSuggestion = showMyTopThreeEmails;
    } else {
        // User not in experiment (e.g. control flight), return original set of three suggestions
        return [triageMyInbox, getOriented, findQuickWins];
    }

    return [showTopActionItems, latestOnTopic, dynamicThirdSuggestion];
}
